import { Data } from 'effect';
export class ServerError extends Data.TaggedError('@fixtuur/backpack/PrologRule/ServerError') {
}
